if (!customElements.get('leo-video')) {
  customElements.define(
    'leo-video',
    class LeoVideo extends HTMLElement {
      connectedCallback() {
        this.poster = this.querySelector('.leo-video__poster');
        this.file = this.querySelector('.leo-video__file');
        if (!this.poster) return;
        if (!this.file) {
          this.poster.addEventListener('click', () => this.play());
          return;
        }
        this.poster.addEventListener('click', () => (this.file.paused || this.file.ended ? this.play() : this.pause()));
        const sync = () => this.sync();
        this.file.addEventListener('play', sync);
        this.file.addEventListener('pause', sync);
        this.file.addEventListener('ended', () => {
          this.classList.remove('is-started');
          sync();
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && !this.file.paused) this.pause();
            });
          });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      sync() {
        const playing = !this.file.paused && !this.file.ended;
        this.classList.toggle('is-playing', playing);
        const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        if (label) this.poster.setAttribute('aria-label', label);
      }

      pause() {
        if (this.file) this.file.pause();
      }

      buildSrc() {
        const id = this.dataset.id;
        if (!id) return null;
        if (this.dataset.provider === 'vimeo') {
          return `https://player.vimeo.com/video/${id}?autoplay=1&title=0&byline=0&portrait=0`;
        }
        return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      }

      play() {
        if (this.file) {
          this.classList.add('is-started');
          const attempt = this.file.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => this.sync());
          return;
        }
        if (this.classList.contains('is-playing')) return;
        const src = this.buildSrc();
        if (!src) return;
        const iframe = document.createElement('iframe');
        iframe.className = 'leo-video__iframe';
        iframe.src = src;
        iframe.title = this.dataset.title || '';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        this.querySelector('.leo-video__frame').appendChild(iframe);
        this.classList.add('is-playing');
        iframe.focus({ preventScroll: true });
      }
    }
  );
}

if (!window.leoStoryBound) {
  window.leoStoryBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-leo-play-story]');
    if (!trigger) return;
    const video = document.querySelector('#leo-story leo-video') || document.querySelector('leo-video');
    if (!video) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    video.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    if (typeof video.play === 'function') video.play();
  });
}